import WWGStorePage from "./WWGStorePage";

export default WWGStorePage;
